import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { useActiveSection } from '../hooks/useActiveSection';
const navItems = [{
  id: 'about',
  label: 'About'
}, {
  id: 'board-experience',
  label: 'Experience'
}, {
  id: 'chair-leadership',
  label: 'Leadership'
}, {
  id: 'governance',
  label: 'Governance'
}, {
  id: 'awards',
  label: 'Recognition'
}, {
  id: 'qualifications',
  label: 'Credentials'
}];
const navIds = ['overview', ...navItems.map(n => n.id), 'contact'];
export function SectionNav() {
  const active = useActiveSection(navIds);
  const [open, setOpen] = useState(false);
  return <header className="fixed inset-x-0 top-0 z-30 border-b border-rule bg-white" data-id="element-231" data-mp="1c0bwji420lev">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-6 px-6 md:px-10" data-id="element-232" data-mp="173bpb3vgxcm6">
        <a href="#overview" className="flex items-center gap-3" aria-label="Jim Godfrey OBE — back to top" data-id="element-233" data-mp="24izdclc0pea5">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-forest ring-2 ring-wheat/70" data-id="element-234" data-mp="1zqfnoq022soz">
            <span className="font-serif text-sm font-semibold text-wheat" data-id="element-235" data-mp="127dp3gq8h6e4">JG</span>
          </span>
          <span className="font-serif text-lg text-forest" data-id="element-236" data-mp="175f7dzfu51oj">Jim Godfrey OBE</span>
        </a>

        <nav aria-label="Portfolio sections" className="hidden xl:block" data-id="element-237" data-mp="te0qby5hnak4">
          <ul className="flex items-center gap-7" data-id="element-238" data-mp="xfcavp9i95lg">
            {navItems.map(item => <li key={item.id} data-id="element-239" data-mp="jg33nf3a1ltm">
                <a href={`#${item.id}`} aria-current={active === item.id ? 'true' : undefined} className={`whitespace-nowrap text-[15px] font-semibold transition-colors duration-150 ${active === item.id ? 'text-wheat' : 'text-forest hover:text-wheat'}`} data-id="element-240" data-mp="jerqionxz1pu">
                  {item.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-2" data-id="element-241" data-mp="28u9cdymvln9p">
          <a href="#contact" className="hidden whitespace-nowrap rounded-full bg-wheat px-6 py-3 text-[15px] font-semibold text-white shadow-[0_10px_24px_-10px_rgba(184,146,63,0.7)] transition-colors duration-150 hover:bg-wheat-dark sm:inline-flex" data-id="element-242" data-mp="28sy6nt9ve5fy">
            Get in Touch
          </a>
          <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} className="flex h-11 w-11 items-center justify-center rounded-full text-forest focus-visible:outline focus-visible:outline-2 focus-visible:outline-wheat xl:hidden" data-id="element-243" data-mp="33szomk4agfcl">
            {open ? <XIcon className="h-5 w-5" data-id="element-244" data-mp="3mq9984lcnyvf" /> : <MenuIcon className="h-5 w-5" data-id="element-245" data-mp="3mr27eh68tg1y" />}
          </button>
        </div>
      </div>

      {open && <nav id="mobile-nav" aria-label="Portfolio sections" className="border-t border-rule bg-white px-6 pb-6 xl:hidden" data-id="element-246" data-mp="o3esm3ryu0da">
          <ul data-id="element-247" data-mp="qlqcezd4u2qt">
            {[...navItems, {
          id: 'contact',
          label: 'Contact'
        }].map(item => <li key={item.id} data-id="element-248" data-mp="vktimn4umf0d">
                <a href={`#${item.id}`} onClick={() => setOpen(false)} className={`block border-b border-rule py-4 text-[15px] font-semibold ${active === item.id ? 'text-wheat' : 'text-forest'}`} data-id="element-249" data-mp="vlw5mjz1vxb0">
                  {item.label}
                </a>
              </li>)}
          </ul>
        </nav>}
    </header>;
}